// extracted by mini-css-extract-plugin
module.exports = {"back":"FloatMessage_back__Kgz3Y","root":"FloatMessage_root__1SBnn"};